import * as _ from 'lodash';

const BASE_MODULES = [
  {
    name: 'login',
    active: {
      default: true,
    },
    visible: {
      default: true,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,

    widgets: {
      default: [
        {
          oder: 0,
          className:
            'grid-xs-12 grid-sm-10 grid-md-8 grid-lg-4 m-auto hv-100 flex flex-align-center flex-justify-center',
          id: 'WebLogin',
          type: 'web-login',
          devID: 'daring-dragon',
          devPath: 'login->default->WebLogin',
        },
      ],
    },
  },

  {
    name: 'forgot-password',

    active: {
      default: true,
    },
    visible: {
      default: true,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,

    widgets: {
      default: [
        {
          oder: 0,
          className:
            'grid-xs-12 grid-sm-10 grid-md-8 grid-lg-4 m-auto hv-100 flex flex-align-center flex-justify-center',
          id: 'ForgotPassword',
          type: 'forgot-password',
          devID: 'daring-narwhal',
          devPath: 'forgot-password->default->ForgotPassword',
        },
      ],
    },
  },
  {
    name: 'register',
    active: {
      default: false,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,

    widgets: {
      default: [
        {
          className: 'grid-xs-12 grid-sm-10 grid-md-8 grid-lg-4 m-auto hv-100 flex flex-align-center flex-justify-center',

          order: 0,
          id: 'Register',
          type: 'register',
          devID: 'glowing-espresso',
          devPath: 'register->default->Register',
        },
      ],
    },
  },
  {
    name: 'account-creation',
    active: {
      default: false,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,

    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-xs-12 grid-sm-10 grid-md-8 grid-lg-4 m-auto hv-100 flex flex-align-center flex-justify-center',

          id: 'AccountCreation',
          type: 'accountCreation-web',
          devID: 'mirthful-kangaroo',
          devPath: 'account-creation->default->AccountCreation',
        },
      ],
    },
  },

  {
    name: 'password-reset',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,

    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-xs-12 grid-sm-10 grid-md-8 grid-lg-5 m-auto hv-100 flex flex-align-center flex-justify-center',

          id: 'PasswordReset',
          type: 'PasswordReset-web',
          devID: 'zesty-marshmallow',
          devPath: 'password-reset->default->PasswordReset',
        },
      ],
    },
  },
  {
    name: 'register-by-invite',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,

    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-xs-12 grid-sm-10 grid-md-8 grid-lg-4 m-auto hv-100 flex flex-align-center flex-justify-center',

          id: 'RegisterByInvite',
          type: 'RegisterByInvite',
          devID: 'daring-lollipop',
          devPath: 'register-by-invite->default->RegisterByInvite',
        },
      ],
    },
  },
  {
    name: 'communities',
    needsAuth: true,
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    sideBar: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    apis: {
      default: [
        'CommunitiesResolver',
        'CommunitiesOverviewResolver',
        'EntitiesResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-6_5',

          data: {
            label: 'communities',
            navigation: false,
            calendar: false,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'rambunctious-dragon',
          devPath: 'communities->default->headerWeb',
        },
        {
          className: 'grid-12 p-1 pt-xs-0',
          order: 1,
          type: 'communitiesTable',
          id: 'communitiesTable',
          devID: 'rambunctious-spoon',
          devPath: 'communities->default->communitiesTable',
        },
      ],
    },
  },
  {
    name: 'community',
    needsAuth: true,
    needsID: true,
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    sideBar: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    apis: {
      default: [
        'CommunityResolver',
        'MembersResolver',
        'EntitiesResolver',
        'EconomicsKpiCommunityResolver',
        'EnergyKpiCommunityResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-6_5',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'community',
            breadCrumbs: true,
            navigation: true,
            calendar: false,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'silly-iceberg',
          devPath: 'community->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 grid-lg-4 p-1 pr-lg-0_5 py-0 pt-xs-0',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'communityBenefitsCard',
          id: 'communityBenefitsCard',
          isOverview: true,
          totalValue: 'total_benefits',
          icon: 'euro',
          kpiContext: 'economics',
          descriptionCallback: 'communityEconomics',
          descriptionType: 'dynamic-label',
          description: 'widgets.communityBenefitsCard.description.default',
          devID: 'waggish-xylophone',
          devPath: 'community->default->communityBenefitsCard',
          additionalFields: [
            {
              field: 'revenues',
              label: 'widgets.communityBenefitsCard.revenues',
            },
            {
              field: 'savings',
              label: 'widgets.communityBenefitsCard.savings',
            }
          ],
          drawerConfig: {
            titleKey: 'drawers.communityTotalEstimatedBenefits.title',
            descriptionKey: 'drawers.communityTotalEstimatedBenefits.description',
            listTitleKey: 'drawers.communityTotalEstimatedBenefits.list_title',
            listTitleSavingsKey: 'drawers.communityTotalEstimatedBenefits.list_title_savings'
          },
        },
        {
          order: 2,
          className: 'grid-xs-12 grid-lg-4 p-1 px-lg-0_5 py-0 pt-lg-0',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'communityEnergyFlowsCard',
          id: 'communityEnergyFlowsCard',
          isOverview: true,
          icon: 'lightning',
          descriptionCallback: 'communityEnergy',
          descriptionType: 'label+value',
          description: [
            {
              key: 'widgets.communityEnergyFlowsCard.description.default.consumption',
              value: 'consumption',
            },
            {
              key: 'widgets.communityEnergyFlowsCard.description.default.production',
              value: 'production',
            },
            {
              key: 'widgets.communityEnergyFlowsCard.description.default.shared',
              value: 'total_shared',
            },
          ],
          devID: 'peculiar-quokka',
          devPath: 'community->default->communityEnergyFlowsCard',
        },
        {
          order: 3,
          className: 'grid-xs-12 grid-lg-4 px-1 pl-lg-0_5 pb-xs-0_5',
          env: 'web',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          devID: 'giddy-cat',
          devPath: 'community->default->map',
        },
        {
          order: 4,
          className: 'grid-xs-12 grid-lg-9 p-1 pt-lg-0 pr-xs-0_5 pl-xs-1',
          type: 'membersTable',
          id: 'membersTable',
          devID: 'jazzy-mango',
          devPath: 'community->default->membersTable',
        },
        {
          order: 5,
          className: 'grid-xs-12 grid-lg-3 p-1 pt-lg-0 pl-lg-0_5',
          type: 'CommunityDetailsParameters',
          id: 'CommunityDetailsParameters',
          data: {
            title: 'widgets.communityCommunityDetailsParameters.title',
            fields: {
              communityId:
                'widgets.communityCommunityDetailsParameters.communityId',
              externalId:
                'widgets.communityCommunityDetailsParameters.externalId',
              communityCode:
                'widgets.communityCommunityDetailsParameters.communityCode',
              communityName:
                'widgets.communityCommunityDetailsParameters.communityName',
              communityType:
                'widgets.communityCommunityDetailsParameters.communityType',
              startDate:
                'widgets.communityCommunityDetailsParameters.startDate',
            },
            shownFields: [
              'externalId',
              'communityName',
              'communityType',
              'startDate',
            ],
          },
          devID: 'happy-avocado',
          devPath: 'community->default->CommunityDetailsParameters',
        },
      ],
    },
  },
  {
    name: 'member',
    needsAuth: true,
    needsID: true,
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    sideBar: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    apis: {
      default: [
        'EntitiesResolver',
        'MembersResolver',
        'MemberResolver',
        'EnergyKpiMemberResolver',
        'EconomicsKpiMemberResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-6_5',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'members',
            breadCrumbs: true,
            navigation: true,
            calendar: false,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'zany-penguin',
          devPath: 'member->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pr-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'memberBenefitsCard',
          id: 'memberBenefitsCard',
          totalValue: 'total_benefits',
          isOverview: true,
          icon: 'euro',
          kpiContext: 'economics',
          descriptionCallback: 'MemberBenefits',
          descriptionType: 'dynamic-label',
          description: 'widgets.memberBenefitsCard.description.default',
          devID: 'jazzy-glove',
          devPath: 'member->default->memberBenefitsCard',
          additionalFields: [
            {
              field: 'revenues',
              label: 'widgets.memberBenefitsCard.revenues',
            },
            {
              field: 'savings',
              label: 'widgets.memberBenefitsCard.savings',
            }
          ],
          drawerConfig: {
            titleKey: 'drawers.memberTotalEstimatedBenefits.title',
            descriptionKey: 'drawers.memberTotalEstimatedBenefits.description',
            listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
            listTitleSavingsKey: 'drawers.memberTotalEstimatedBenefits.list_title_savings'
          },
        },
        {
          order: 2,
          className: 'grid-xs-12 grid-lg-4 px-1 pt-xs-0 pb-xs-0_5 px-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'memberEnergyFlowsCard',
          id: 'memberEnergyFlowsCard',
          icon: 'lightning',
          descriptionCallback: 'memberEnergy',
          descriptionType: '[member]label+value',
          isOverview: true,
          description: [
            {
              key: 'widgets.memberEnergyFlowsCard.description.default.consumption',
              value: 'consumption',
            },
            {
              key: 'widgets.memberEnergyFlowsCard.description.default.production',
              value: 'production',
            },
            {
              key: 'widgets.memberEnergyFlowsCard.description.default.self_consumption',
              value: 'self_consumption',
            },
          ],
          devID: 'rambunctious-shoe',
          devPath: 'member->default->memberEnergyFlowsCard',
        },
        {
          order: 3,
          className: 'grid-xs-12 grid-lg-4 px-1 pt-xs-0 pb-xs-0_5 pl-lg-0_5',
          env: 'web',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          context: 'member',
          devID: 'nutty-quokka',
          devPath: 'member->default->map',
        },
        {
          order: 4,
          className: 'grid-xs-12 grid-lg-9 p-1 py-xs-0 pr-lg-0_5',
          type: 'paymentsTable',
          id: 'paymentsTable',
          devID: 'waggish-marshmallow',
          devPath: 'member->default->paymentsTable',
        },
        {
          className: 'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pl-lg-0_5',
          order: 5,
          type: 'MemberDetailsParameters',
          id: 'MemberDetailsParameters',
          data: {
            title: 'widgets.memberDetailsParameters.title',
            fields: {
              communityId: 'widgets.memberDetailsParameters.communityId',
              externalId: 'widgets.memberDetailsParameters.externalId',
              communityCode: 'widgets.memberDetailsParameters.communityCode',
              communityName: 'widgets.memberDetailsParameters.communityName',
              communityType: 'widgets.memberDetailsParameters.communityType',
              startDate: 'widgets.memberDetailsParameters.startDate',
              memberId: 'widgets.memberDetailsParameters.memberId',
              clientId: 'widgets.memberDetailsParameters.clientId',
              name: 'widgets.memberDetailsParameters.name',
              address: 'widgets.memberDetailsParameters.address',
              city: 'widgets.memberDetailsParameters.city',
              postcode: 'widgets.memberDetailsParameters.postcode',
              phone: 'widgets.memberDetailsParameters.phone',
              email: 'widgets.memberDetailsParameters.email',
            },
            sitesNumber: 'widgets.memberDetailsParameters.sitesNumber',
            shownFields: ['memberId', 'address', 'city', 'phone', 'email'],
          },
          devID: 'glowing-lighthouse',
          devPath: 'member->default->MemberDetailsParameters',
        },
        {
          order: 6,
          className:
            'grid-xs-12 grid-md-6 grid-lg-3 ml-lg-auto p-1 py-lg-0 pl-lg-0_5',
          type: 'memberSitesList',
          id: 'memberSitesList',
          devID: 'golden-pajamas',
          devPath: 'member->default->memberSitesList',
        },
      ],
    },
  },
  {
    name: 'member-economics',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'EntitiesResolver',
        'MemberResolver',
        'EconomicsKpiMemberResolver',
        'EconomicsMemberRankingResolver',
        'EconomicsCustomKpiMemberResolver',

      ],
    },
    widgets: {
      default: [
        {
          type: 'headerWeb',
          id: 'headerWeb',
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-6_5',
          orider: 0,
          data: {
            label: 'member-economics',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'jazzy-waffle',
          devPath: 'member-economics->default->headerWeb',
        },
        {
          className: 'grid-12 p-1 pt-xs-0 pb-xs-0_5',
          order: 1,
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'memberSavingsCard',
          id: 'memberSavingsCard',
          totalValue: 'total_benefits',
          icon: 'savings',
          descriptionType: 'dynamic-label',
          description: 'widgets.memberSavingsCard.description.default',
          descriptionCallback: 'memberTotalEstimatedBenefits',
          kpiContext: 'economics',
          kpiApiContext: 'economics',
          devID: 'clumsy-butterfly',
          devPath: 'member-economics->default->memberSavingsCard',
          additionalFields: [
            {
              field: 'revenues',
              label: 'widgets.memberSavingsCard.revenues',
            },
            {
              field: 'savings',
              label: 'widgets.memberSavingsCard.savings',
            }
          ],
          drawerConfig: {
            titleKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.title',
            descriptionKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.description',
            listTitleKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.list_title',
            listTitleSavingsKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.list_title_savings'
          },
        },
        {
          order: 2,
          className: 'grid-12 p-1 py-xs-0_5',
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'savingsStackBar',
          id: 'savingsStackBar',
          totalValue: 'total_benefits',
          graphKeys: [
            {
              key: 'revenues',
              color: 'revenues',
              combined: false,
            },
            {
              key: 'savings',
              color: 'savings',
              combined: false,
            },
          ],
          colors: ['revenues', 'savings'],
          title: 'widgets.savingsStackBar.title',
          devID: 'zealous-pajamas',
          devPath: 'member-economics->default->savingsStackBar',
        },
        {
          order: 3,
          className: 'grid-12 p-1 py-xs-0_5',
          type: 'horizontalChart',
          gradientBorder: false,
          subtype: 'horizontalChart',
          id: 'horizontalChartEconomics',
          entity: 'member',
          context: 'economics',
          rankingKpi: 'total_benefits',
          rankingKpiName: 'widgets.horizontalChart.economics.benefits',
          graphKeys: ['revenues', 'savings'],
          combinedKeys: [],
          hideCondition: (rowsNumber: number) => {
            return rowsNumber < 2;
          },
          buttons: [
            'widgets.horizontalChart.economics.benefits',
            'widgets.horizontalChart.economics.savings',
          ],
          colors: [
            {
              color: 'revenues',
              colorShade: '',
            },
            {
              color: 'savings',
              colorShade: '',
            },
          ],
          title: 'widgets.horizontalChart.economics.title',
          devID: 'vivacious-octopus',
          devPath: 'member-economics->default->horizontalChart',
        },
      ],
    },
  },
  {
    name: 'member-energy',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'EntitiesResolver',
        'MemberResolver',
        'EnergyKpiMemberResolver',
        'AncillaryKpiMemberResolver',
        'EnergyMemberRankingResolver',
        'EnergyCustomKpiMemberResolver',

      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-5_5',
          data: {
            label: 'community-energy',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'mystical-spoon',
          devPath: 'member-energy->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'memberStatsOverviewConsumption',
          totalValue: 'consumption',
          color: 'consumption',
          view: 'member',
          graphDataKeys: [
            {
              key: 'self_consumption_direct',
              percentage: 'consumption_self_consumption_direct_rate',
              label:
                'widgets.memberStatsOverviewConsumption.self_consumption_direct',
            },
            {
              key: 'from_grid',
              percentage: 'consumption_from_grid_rate',
              label: 'widgets.memberStatsOverviewConsumption.from_grid',
            },
          ],
          graphColors: ['self_consumption', 'from_grid'],
          title: 'widgets.memberStatsOverviewConsumption.title',
          devID: 'zesty-marshmallow',
          devPath: 'member-energy->default->memberStatsOverviewConsumption',
        },
        {
          order: 2,
          className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'memberStatsOverviewProduction',
          totalValue: 'production',
          color: 'production',
          view: 'member',
          graphDataKeys: [
            {
              key: 'self_consumption_direct',
              percentage: 'production_self_consumption_direct_rate',
              label:
                'widgets.memberStatsOverviewProduction.self_consumption_direct',
            },
            {
              key: 'to_grid',
              percentage: 'production_to_grid_rate',
              label: 'widgets.memberStatsOverviewProduction.to_grid',
            },
          ],
          graphColors: ['self_consumption', 'to_grid'],
          title: 'widgets.memberStatsOverviewProduction.title',
          devID: 'witty-dragon',
          devPath: 'member-energy->default->memberStatsOverviewProduction',
        },
        {
          order: 3,
          className: 'grid-xs-12 grid-lg-4 pb-0_5',
          env: 'web',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          devID: 'wild-pencil',
          devPath: 'member-energy->default->map',
        },
        {
          order: 4,
          className: 'grid-xs-12 grid-lg-4 px-1 py-0_5 pr-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,
          subtype: 'memberSelfSufficiencyCard',
          id: 'memberSelfSufficiencyCard',
          totalValue: 'self_sufficiency_rate',
          value: 'self_consumption',
          icon: 'self_sufficiency',
          descriptionType: 'label+value+unit',
          description: 'widgets.memberSelfSufficiencyCard.description.default',
          devID: 'hysterical-jellyfish',
          devPath: 'member-energy->default->memberSelfSufficiencyCard',
        },
        {
          order: 5,
          className: 'grid-xs-12 grid-lg-4 px-1 pt-xs-0 pb-0_5 px-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,
          subtype: 'memberSharedEnergyCard',
          id: 'memberSharedEnergyCard',
          totalValue: 'total_shared',
          icon: 'shared_energy',
          descriptionType: 'web:label+value|label+value',
          description: [
            {
              key: 'widgets.memberSharedEnergyCard.description.key_1',
              value: 'from_shared',
            },
            {
              key: 'widgets.memberSharedEnergyCard.description.key_2',
              value: 'to_shared',
            },
          ],
          devID: 'rampaging-octopus',
          devPath: 'member-energy->default->memberSharedEnergyCard',
        },
        {
          order: 6,
          className: 'grid-xs-12 grid-lg-4  px-1 pt-xs-0 pb-0_5 px-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,
          subtype: 'memberPollutionCard',
          id: 'memberPollutionCard',
          totalValue: 'co2_offset_kgs',
          trees: 'co2_offset_trees',
          icon: 'pollution',
          descriptionValue: 'co2_offset_trees',
          descriptionType: '{{trees}}',
          description: {
            line_1: 'widgets.memberPollutionCard.description.prosumer.line_1',
            line_2: 'widgets.memberPollutionCard.description.prosumer.line_2',
          },
          devID: 'boisterous-spoon',
          devPath: 'member-energy->default->memberPollutionCard',
        },
        {
          order: 7,
          className: 'grid-xs-12 grid-lg-6 px-1 pt-xs-0_5 pb-xs-0_5',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'consumptionStackBar',
          id: 'consumptionStackBar',
          totalValue: 'consumption',
          graphKeys: [
            {
              key: 'self_consumption_direct',
              color: 'self_consumption',
              combined: false,
            },
            {
              key: 'self_consumption_battery',
              color: 'self_consumption_battery',
              combined: false,
            },
            {
              key: 'from_shared',
              color: 'from_shared',
              combined: true,
              base: false,
            },
            {
              key: 'from_grid',
              color: 'from_grid',
              combined: true,
              base: true,
            },
          ],

          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'self_consumption_battery',
              colorShade: '',
            },
            {
              color: 'from_shared',
              colorShade: '',
            },
            {
              color: 'from_grid',
              colorShade: '60',
            },
          ],
          title: 'widgets.consumptionStackBar.title',
          devID: 'whacky-quokka',
          devPath: 'member-energy->default->consumptionStackBar',
        },
        {
          order: 8,
          className: 'grid-xs-12 grid-lg-6 mt-0_5 py-0_5 pl-0_5 pr-1',
          type: 'graphs',
          gradientBorder: false,
          env: 'web',
          subtype: 'productionStackBar',
          id: 'productionStackBar',
          totalValue: 'production',
          graphKeys: [
            {
              key: 'self_consumption_direct',
              color: 'self_consumption',
              combined: false,
            },
            {
              key: 'production_to_battery',
              color: 'production_to_battery',
              combined: false,
            },
            {
              key: 'to_shared',
              color: 'to_shared',
              combined: true,
              base: false,
            },
            {
              key: 'to_grid',
              color: 'to_grid',
              combined: true,
              base: true,
            },
          ],

          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'production_to_battery',
              colorShade: '',
            },
            {
              color: 'to_shared',
              colorShade: '',
            },
            {
              color: 'to_grid',
              colorShade: '',
            },
          ],
          title: 'widgets.productionStackBar.title',
          devID: 'zippy-lollipop',
          devPath: 'member-energy->default->productionStackBar',
        },
        {
          order: 9,
          className: 'grid-xs-12 grid-lg-6 mt-0_5 py-0_5 pl-1 pr-0_5',
          id: 'batteryChart',
          title: 'widgets.batteryChart.title',
          type: 'batteryChart',
          gradientBorder: false,
          context: 'member',
          buttons: ['widgets.batteryChart.self_consumption'],
          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
          ],
          db_fields: ['battery_net_flow'],
          devID: 'bizarre-marshmallow',
          devPath: 'member-energy->default->batteryChart',
        },
        {
          order: 10,
          className: 'grid-xs-12 grid-lg-6 px-1 py-0_5',
          env: 'web',
          id: 'areaChartSelfConsumption',
          title: 'widgets.areaChartSelfConsumptionCommunity.title',
          type: 'areaChart',
          subtype: 'areaChart',
          gradientBorder: false,
          view: 'community',
          graphKeys: ['consumption', 'production', 'self_consumption'],
          colors: ['consumption', 'production', 'self_consumption'],
          devID: 'mirthful-dragon',
          devPath: 'member-energy->default->areaChartSelfConsumption',
        },
        {
          order: 11,
          className: 'grid-12 mt-0_5 py-0_5 px-1',
          type: 'horizontalChart',
          gradientBorder: false,
          subtype: 'horizontalChart',
          id: 'horizontalChart',
          context: 'energy',
          rankingKpi: 'consumption',
          rankingKpiName: [
            'widgets.horizontalChart.energy.consumption',
            'widgets.horizontalChart.energy.production',
          ],
          graphKeys: [
            [
              'self_consumption_direct',
              'self_consumption_battery',
              'from_shared',
              'from_grid',
            ],
            [
              'self_consumption_direct',
              'production_to_battery',
              'to_shared',
              'to_grid',
            ],
          ],
          combinedKeys: ['from_shared', 'from_grid'],
          buttons: [
            'widgets.horizontalChart.energy.self_consumption_direct',
            'widgets.horizontalChart.energy.self_consumption_battery',
            'widgets.horizontalChart.energy.from_shared',
            'widgets.horizontalChart.energy.from_grid',
          ],
          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'total_battery',
              colorShade: '',
            },
            {
              color: 'total_shared',
              colorShade: '',
            },
            {
              color: 'total_grid',
              colorShade: '60',
            },
          ],
          title: 'widgets.horizontalChart.energy.title',
          devID: 'hysterical-penguin',
          devPath: 'member-energy->default->horizontalChart',
        },
      ],
      administrator: {
        consumer: [
          {
            id: 'memberStatsOverviewConsumption',
            keep: false,
          },
          {
            id: 'memberStatsOverviewProduction',
            keep: false,
          },
          {
            id: 'memberSelfSufficiencyCard',
            keep: false,
          },
          {
            id: 'memberPollutionCard',
            keep: false,
          },
          {
            id: 'memberSharedEnergyCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumption',
            keep: false,
          },

          {
            order: 1,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-1 pb-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalConsumptionCard',
            id: 'totalConsumptionCard',
            totalValue: 'consumption',
            icon: 'house_import',
            descriptionValue: 'consumption',
            descriptionType: 'label',
            description: 'widgets.totalConsumptionCard.description.consumer',
            devID: 'daring-cabbage',
            devPath:
              'member-energy->administrator->consumer->totalConsumptionCard',
          },
          {
            order: 2,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0_5 pt-lg-1 pb-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'label',
            description: 'widgets.sharedEnergyCard.description.consumer.key_1',
            devID: 'fantastic-mango',
            devPath: 'member-energy->administrator->consumer->sharedEnergyCard',
          },

          {
            order: 3,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0_5 pt-lg-1 pb-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            devID: 'quirksome-cabbage',
            devPath: 'member-energy->administrator->consumer->pollutionCard',
          },

          {
            order: 4,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0_5 pt-lg-1 pb-0_5 pl-lg-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'member-energy',
            devID: 'bizarre-rhinoceros',
            devPath: 'member-energy->administrator->consumer->map',
          },
          {
            order: 5,
            className: 'grid-12 px-1 py-0_5',
            id: 'consumptionStackBar',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'ludicrous-dragon',
            devPath:
              'member-energy->administrator->consumer->consumptionStackBar',
          },
          {
            order: 6,
            className: 'grid-12 px-1 py-0_5',
            type: 'horizontalChart',
            gradientBorder: false,
            subtype: 'horizontalChart',
            id: 'horizontalChart',
            context: 'energy',
            rankingKpi: 'consumption',
            rankingKpiName: 'widgets.horizontalChart.energy.consumption',
            graphKeys: ['from_shared', 'from_grid'],
            combinedKeys: ['from_shared', 'from_grid'],
            buttons: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'zesty-waffle',
            devPath: 'member-energy->administrator->consumer->horizontalChart',
          },
        ],
        producer: [
          {
            id: 'memberStatsOverviewConsumption',
            keep: false,
          },
          {
            id: 'memberSelfSufficiencyCard',
            keep: false,
          },
          {
            id: 'memberSharedEnergyCard',
            keep: false,
          },
          {
            id: 'memberPollutionCard',
            keep: false,
          },
          {
            id: 'consumptionStackBar',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumption',
            keep: false,
          },

          {
            order: 1,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0 pb-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalProductionCard',
            id: 'totalProductionCard',
            totalValue: 'production',
            icon: 'house_export',
            descriptionValue: 'production',
            descriptionType: 'label',
            description: 'widgets.totalProductionCard.description.producer',
            devID: 'turbulent-cat',
            devPath:
              'member-energy->administrator->producer->totalProductionCard',
          },
          {
            order: 2,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0 pb-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'keyValue',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.producer.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.producer.key_2',
                value: 'to_shared',
              },
            ],
            devID: 'rampaging-cat',
            devPath: 'member-energy->administrator->producer->sharedEnergyCard',
          },
          {
            order: 3,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0 pb-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'daring-xylophone',
            devPath: 'member-energy->administrator->producer->pollutionCard',
          },
          {
            order: 4,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0 pb-0_5 pl-lg-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'member-energy',
            devID: 'mystical-cabbage',
            devPath: 'member-energy->administrator->producer->map',
          },
          {
            order: 5,
            className: 'grid-12 px-1 py-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: true,
              },
            ],

            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'frisky-hamburger',
            devPath:
              'member-energy->administrator->producer->productionStackBar',
          },
          {
            order: 6,
            className: 'grid-12 px-1 py-0_5',
            type: 'horizontalChart',
            gradientBorder: false,
            subtype: 'horizontalChart',
            id: 'horizontalChart',
            context: 'energy',
            rankingKpi: 'production',
            rankingKpiName: 'widgets.horizontalChart.energy.production',
            graphKeys: ['production_to_battery', 'to_shared', 'to_grid'],
            combinedKeys: ['to_shared', 'to_grid'],
            buttons: [
              'widgets.horizontalChart.energy.to_shared',
              'widgets.horizontalChart.energy.to_grid',
            ],
            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'peculiar-lighthouse',
            devPath: 'member-energy->administrator->producer->horizontalChart',
          },
        ],
        consumer_producer: [
          {
            id: 'memberSelfSufficiencyCard',
            keep: false,
          },
          {
            id: 'memberPollutionCard',
            keep: false,
          },
          {
            id: 'memberSharedEnergyCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'horizontalChart',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumption',
            keep: false,
          },

          {
            order: 4,
            className: 'grid-xs-12 grid-md-6 grid-lg-3',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalConsumptionCard',
            id: 'totalConsumptionCard',
            totalValue: 'consumption',
            icon: 'house_import',
            descriptionValue: 'consumption',
            descriptionType: 'label',
            description: 'widgets.totalConsumptionCard.description.consumer',
            devID: 'oddball-giraffe',
            devPath:
              'member-energy->administrator->consumer_producer->totalConsumptionCard',
          },
          {
            order: 5,
            env: 'web',
            className: 'grid-xs-12 grid-md-6 grid-lg-3',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalProductionCard',
            id: 'totalProductionCard',
            totalValue: 'production',
            icon: 'house_export',
            descriptionValue: 'production',
            descriptionType: 'label',
            description: 'widgets.totalProductionCard.description.producer',
            devID: 'glowing-cactus',
            devPath:
              'member-energy->administrator->consumer_producer->totalProductionCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-md-6 grid-lg-3',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'label',
            description:
              'widgets.memberSharedEnergyCard.description.consumer.key_1',
            devID: 'eccentric-espresso',
            devPath:
              'member-energy->administrator->consumer_producer->sharedEnergyCard',
          },
          {
            order: 7,
            className: 'grid-xs-12 grid-md-6 grid-lg-3 px-1 py-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'wild-kangaroo',
            devPath:
              'member-energy->administrator->consumer_producer->pollutionCard',
          },

          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'nutty-penguin',
            devPath:
              'member-energy->administrator->consumer_producer->consumptionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-glove',
            devPath:
              'member-energy->administrator->consumer_producer->productionStackBar',
          },
          {
            order: 10,
            className: 'grid-12 px-1 pt-xs-0_5',
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',

            kpiNameLabels: ['consumption', 'production'],
            id: 'horizontalChartDouble',
            context: 'energy',
            rankingKpi: 'consumption',
            rankingKpiName: [
              'widgets.horizontalChart.energy.consumption',
              'widgets.horizontalChart.energy.production',
            ],
            graphKeys: [
              ['self_consumption_direct', 'from_shared', 'from_grid'],
              ['self_consumption_direct', 'to_shared', 'to_grid'],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.self_consumption_direct',
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'eccentric-banana',
            devPath:
              'member-energy->administrator->consumer_producer->horizontalChartDouble',
          },
        ],
        prosumer: [
          {
            id: 'memberPollutionCard',
            keep: false,
          },
          {
            id: 'memberSharedEnergyCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'horizontalChart',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },

          {
            order: 6,
            className: 'grid-xs-12 grid-lg-4 px-1 py-0_5 px-lg-0_5 ',
            subtype: 'sharedEnergyCard',
            id: 'memberSharedEnergyCard',
          },
          {
            order: 7,
            className: 'grid-xs-12 grid-lg-4 px-1 py-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'wild-kangaroo',
            devPath:
              'member-energy->administrator->consumer_producer->pollutionCard',
          },

          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'nutty-panchin',
            devPath:
              'member-energy->administrator->consumer_producer->consumptionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-melina',
            devPath:
              'member-energy->administrator->consumer_producer->productionStackBar',
          },

          {
            order: 10,
            id: 'areaChartSelfConsumption',
            className: 'grid-12 px-1 py-0_5',
          },
          {
            order: 11,
            className: 'grid-12 px-1 py-0_5',
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            context: 'energy',
            rankingKpi: 'consumption',

            kpiNameLabels: ['consumption', 'production'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.consumption',
              'widgets.horizontalChart.energy.production',
            ],
            graphKeys: [
              ['self_consumption_direct', 'from_shared', 'from_grid'],
              ['self_consumption_direct', 'to_shared', 'to_grid'],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.self_consumption_direct',
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'eccentric-banana',
            devPath:
              'member-energy->administrator->consumer_producer->horizontalChartDouble',
          },
        ],
        prosumage: [
          {
            id: 'horizontalChart',
            keep: false,
          },

          {
            order: 1,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            view: 'member',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'consumption_self_consumption_direct_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_direct',
              },
              {
                key: 'self_consumption_battery',
                percentage: 'consumption_self_consumption_battery_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                percentage: 'consumption_from_grid_rate',
                label: 'widgets.memberStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'self_consumption_battery',
              'from_grid',
            ],
            title: 'widgets.memberStatsOverviewConsumption.title',
            devID: 'quirky-hedgehog',
            devPath:
              'member-energy->administrator->prosumage->memberStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            view: 'member',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'production_self_consumption_direct_rate',
                label:
                  'widgets.memberStatsOverviewProduction.self_consumption_direct',
              },
              {
                key: 'production_to_battery',
                percentage: 'production_to_battery_rate',
                label:
                  'widgets.memberStatsOverviewProduction.production_to_battery',
              },
              {
                key: 'to_grid',
                percentage: 'production_to_grid_rate',
                label: 'widgets.memberStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'production_to_battery',
              'to_grid',
            ],
            title: 'widgets.memberStatsOverviewProduction.title',
            devID: 'unruly-penguin',
            devPath:
              'member-energy->administrator->prosumage->memberStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            devID: 'vivacious-dragon',
            devPath: 'member-energy->administrator->prosumage->map',
          },
          {
            order: 4,
            className: 'grid-xs-12 grid-lg-4 p-1 pt-lg-0_5 pb-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberSelfSufficiencyCard',
            id: 'memberSelfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            value: 'self_consumption',
            icon: 'self_sufficiency',
            descriptionType: 'label+value+unit',
            description:
              'widgets.memberSelfSufficiencyCard.description.default',
            devID: 'happy-jellyfish',
            devPath:
              'member-energy->administrator->prosumage->memberSelfSufficiencyCard',
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pt-lg-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberSharedEnergyCard',
            id: 'memberSharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.memberSharedEnergyCard.description.default.key_1',
                value: 'consumption',
              },
              {
                key: 'widgets.memberSharedEnergyCard.description.default.key_2',
                value: 'production',
              },
            ],
            devID: 'waggish-ukulele',
            devPath:
              'member-energy->administrator->prosumage->memberSharedEnergyCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pt-lg-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberPollutionCard',
            id: 'memberPollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            kpiContext: 'ancillary',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.memberPollutionCard.description.prosumer.line_1',
              line_2: 'widgets.memberPollutionCard.description.prosumer.line_2',
            },
            devID: 'quirky-cactus',
            devPath:
              'member-energy->administrator->prosumage->memberPollutionCard',
          },
          {
            order: 7,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'angry-obelisk',
            devPath:
              'member-energy->administrator->prosumage->consumptionStackBar',
          },
          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-espresso',
            devPath:
              'member-energy->administrator->prosumage->productionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            id: 'batteryChart',
            title: 'widgets.batteryChart.title',
            type: 'batteryChart',
            gradientBorder: false,
            context: 'member',
            buttons: ['widgets.batteryChart.self_consumption'],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
            ],
            db_fields: ['battery_net_flow'],
            devID: 'zealous-yogurt',
            devPath: 'member-energy->administrator->prosumage->batteryChart',
          },
          {
            order: 10,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'community',
            graphKeys: ['consumption', 'production', 'self_consumption'],
            colors: ['consumption', 'production', 'self_consumption'],
            devID: 'zesty-penguin',
            devPath:
              'member-energy->administrator->prosumage->areaChartSelfConsumption',
          },
          {
            order: 11,
            className: 'grid-12 px-1 py-0_5',
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            context: 'energy',
            rankingKpi: 'consumption',
            kpiNameLabels: ['consumption', 'production'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.consumption',
              'widgets.horizontalChart.energy.production',
            ],
            graphKeys: [
              [
                'self_consumption_direct',
                'self_consumption_battery',
                'from_shared',
                'from_grid',
              ],
              [
                'self_consumption_direct',
                'production_to_battery',
                'to_shared',
                'to_grid',
              ],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.self_consumption_direct',
              'widgets.horizontalChart.energy.self_consumption_battery',
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_battery',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'nocturnal-pencil',
            devPath:
              'member-energy->administrator->prosumage->horizontalChartDouble',
          },
        ],
        prosumer_battery: [
          {
            id: 'horizontalChart',
            keep: false,
          },

          {
            order: 1,
            env: 'web',
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            view: 'member',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'consumption_self_consumption_direct_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_direct',
              },
              {
                key: 'self_consumption_battery',
                percentage: 'consumption_self_consumption_battery_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                percentage: 'consumption_from_grid_rate',
                label: 'widgets.memberStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'self_consumption_battery',
              'from_grid',
            ],
            title: 'widgets.memberStatsOverviewConsumption.title',
            devID: 'quirky-hedgehog',
            devPath:
              'member-energy->administrator->prosumage->memberStatsOverviewConsumption',
          },
          {
            order: 2,
            env: 'web',
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            view: 'member',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'production_self_consumption_direct_rate',
                label:
                  'widgets.memberStatsOverviewProduction.self_consumption_direct',
              },
              {
                key: 'production_to_battery',
                percentage: 'production_to_battery_rate',
                label:
                  'widgets.memberStatsOverviewProduction.production_to_battery',
              },
              {
                key: 'to_grid',
                percentage: 'production_to_grid_rate',
                label: 'widgets.memberStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'production_to_battery',
              'to_grid',
            ],
            title: 'widgets.memberStatsOverviewProduction.title',
            devID: 'unruly-penguin',
            devPath:
              'member-energy->administrator->prosumage->memberStatsOverviewProduction',
          },
          {
            className: 'grid-xs-12 grid-lg-4 pb-xs-1 pb-lg-0_5',
            order: 3,
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            devID: 'vivacious-dragon',
            devPath: 'member-energy->administrator->prosumage->map',
          },
          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pt-lg-0_5 pr-lg-0_5',
            order: 4,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberSelfSufficiencyCard',
            id: 'memberSelfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            value: 'self_consumption',
            icon: 'self_sufficiency',
            descriptionType: 'label+value+unit',
            description:
              'widgets.memberSelfSufficiencyCard.description.default',
            devID: 'happy-jellyfish',
            devPath:
              'member-energy->administrator->prosumage->memberSelfSufficiencyCard',
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pt-lg-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberSharedEnergyCard',
            id: 'memberSharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.memberSharedEnergyCard.description.key_1',
                value: 'consumption',
              },
              {
                key: 'widgets.memberSharedEnergyCard.description.key_2',
                value: 'production',
              },
            ],
            devID: 'waggish-ukulele',
            devPath:
              'member-energy->administrator->prosumage->memberSharedEnergyCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pt-lg-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberPollutionCard',
            id: 'memberPollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            kpiContext: 'ancillary',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.memberPollutionCard.description.prosumer.line_1',
              line_2: 'widgets.memberPollutionCard.description.prosumer.line_2',
            },
            devID: 'quirky-orange',
            devPath:
              'member-energy->administrator->prosumage->memberPollutionCard',
          },
          {
            order: 7,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'angry-obelisk',
            devPath:
              'member-energy->administrator->prosumage->consumptionStackBar',
          },
          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-espresso',
            devPath:
              'member-energy->administrator->prosumage->productionStackBar',
          },
          {
            order: 9,

            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            id: 'batteryChart',
            title: 'widgets.batteryChart.title',
            type: 'batteryChart',
            gradientBorder: false,
            context: 'member',
            buttons: ['widgets.batteryChart.self_consumption'],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
            ],
            db_fields: ['battery_net_flow'],
            devID: 'zealous-yogurt',
            devPath: 'member-energy->administrator->prosumage->batteryChart',
          },
          {
            order: 10,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'community',
            graphKeys: ['consumption', 'production', 'self_consumption'],
            colors: ['consumption', 'production', 'self_consumption'],
            devID: 'zesty-penguin',
            devPath:
              'member-energy->administrator->prosumage->areaChartSelfConsumption',
          },
          {
            order: 11,
            className: 'grid-12 p-1 py-xs-0_5',
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            context: 'energy',
            rankingKpi: 'consumption',
            kpiNameLabels: ['consumption', 'production'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.consumption',
              'widgets.horizontalChart.energy.production',
            ],
            graphKeys: [
              [
                'self_consumption_direct',
                'self_consumption_battery',
                'from_shared',
                'from_grid',
              ],
              [
                'self_consumption_direct',
                'production_to_battery',
                'to_shared',
                'to_grid',
              ],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.self_consumption_direct',
              'widgets.horizontalChart.energy.self_consumption_battery',
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_battery',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'nocturnal-pencil',
            devPath:
              'member-energy->administrator->prosumage->horizontalChartDouble',
          },
        ],
      },
    },
  },
  {
    name: 'site',
    needsAuth: true,
    needsID: true,
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    sideBar: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    apis: {
      default: [
        'EntitiesResolver',
        'SiteOverviewResolver',
        'EnergyKpiSiteResolver',
        'EconomicsKpiSiteResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-6_5',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'site',
            breadCrumbs: true,
            navigation: true,
            calendar: false,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'happy-shoe',
          devPath: 'site->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 grid-lg-4 p-1 pb-xs-0_5 pt-lg-0 pr-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'siteBenefitsCard',
          id: 'siteBenefitsCard',
          isOverview: true,
          totalValue: 'total_benefits',
          icon: 'euro',
          descriptionCallback: 'siteEconomics',
          descriptionType: 'dynamic-label',
          kpiContext: 'economics',
          description: 'widgets.savingsCard.description.default',
          devID: 'cannibal-firecracker',
          devPath: 'site->default->siteBenefitsCard',

          additionalFields: [
            {
              field: 'revenues',
              label: 'widgets.savingsCard.revenues',
            },
            {
              field: 'savings',
              label: 'widgets.savingsCard.savings',
            }
          ],
          drawerConfig: {
            titleKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.title',
            descriptionKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.description',
            listTitleKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.list_title',
            listTitleSavingsKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.list_title_savings'
          },
        },
        {
          env: 'web',
          order: 2,
          className: 'grid-xs-12 grid-lg-4 p-1 pb-xs-0_5 pt-lg-0 px-lg-0_5',
          type: 'card',
          gradientBorder: false,
          subtype: 'siteEnergyFlowsCard',
          id: 'siteEnergyFlowsCard',
          isOverview: true,
          icon: 'euro',
          descriptionCallback: 'siteEnergy',
          descriptionType: 'siteType[label+value]',
          description: {
            default: [
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.consumption',
                value: 'consumption',
              },
            ],
            consumer: [
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.consumption',
                value: 'consumption',
              },
            ],
            producer: [
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.production',
                value: 'production',
              },
            ],
            prosumage: [
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.consumption',
                value: 'consumption',
              },
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.production',
                value: 'production',
              },
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.self_consumption',
                value: 'self_consumption',
              },
            ],
            prosumer: [
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.consumption',
                value: 'consumption',
              },
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.production',
                value: 'production',
              },
              {
                key: 'widgets.siteEnergyFlowsCard.description.default.self_consumption',
                value: 'self_consumption',
              },
            ],
          },
          devID: 'wild-tangerine',
          devPath: 'site->default->siteEnergyFlowsCard',
        },
        {
          env: 'web',
          order: 3,
          className: 'grid-xs-12 grid-lg-4 p-1 pb-xs-0_5 pt-lg-0 pl-lg-0_5',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          context: 'site',
          devID: 'giddy-jigsaw',
          devPath: 'site->default->map',
        },
        {
          order: 4,
          className: 'grid-xs-12 grid-lg-9 p-1 py-xs-0_5 pr-lg-0_5',
          type: 'sitePaymentsTable',
          id: 'sitePaymentsTable',
          devID: 'unruly-narwhal',
          devPath: 'site->default->sitePaymentsTable',
        },
        {
          order: 5,
          className: 'grid-xs-12 grid-md-6 grid-lg-3 p-1 py-xs-0_5 pl-lg-0_5',
          type: 'SiteDetailsParameters',
          id: 'SiteDetailsParameters',
          data: {
            title: 'widgets.siteDetailsParameters.title',
            siteName: 'widgets.siteDetailsParameters.siteName',
            joinDate: 'widgets.siteDetailsParameters.joinDate',
            ownership: 'widgets.siteDetailsParameters.ownership',
            type: 'widgets.siteDetailsParameters.type',
            productionBenefits:
              'widgets.siteDetailsParameters.productionBenefits',
          },
          devID: 'vivacious-obelisk',
          devPath: 'site->default->SiteDetailsParameters',
        },
        {
          order: 6,
          className:
            'grid-xs-12 grid-md-6 grid-lg-3 ml-lg-auto p-1 py-xs-0_5 pl-lg-0_5',
          type: 'siteMembersList',
          id: 'siteMembersList',
          devID: 'rambunctious-dinosaur',
          devPath: 'site->default->siteMembersList',
        },
      ],
    },
  },
  {
    name: 'site-economics',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'EntitiesResolver',
        'SiteOverviewResolver',
        'EconomicsKpiSiteResolver',
        'EconomicsCustomKpiSiteResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-6_5',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'site-economics',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'waggish-jellyfish',
          devPath: 'site-economics->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-12 p-1 pb-xs-0_5 pt-xs-0',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'savingsCard',
          id: 'savingsCard',
          totalValue: 'total_benefits',
          icon: 'savings',
          descriptionType: 'dynamic-label',
          descriptionCallback: 'SiteTotalEstimatedBenefits',
          description: 'widgets.savingsCard.description.default',
          devID: 'happy-pencil',
          devPath: 'site-economics->default->savingsCard',
          additionalFields: [
            {
              field: 'revenues',
              label: 'widgets.savingsCard.revenues',
            },
            {
              field: 'savings',
              label: 'widgets.savingsCard.savings',
            }
          ],
          drawerConfig: {
            titleKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.title',
            descriptionKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.description',
            listTitleKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.list_title',
            listTitleSavingsKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.list_title_savings'
          },
        },
        {
          order: 2,
          className: 'grid-12 p-1 py-xs-0_5',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'savingsStackBar',
          id: 'savingsStackBar',
          totalValue: 'total_benefits',
          graphKeys: [
            {
              key: 'revenues',
              color: 'revenues',
              combined: false,
            },
            {
              key: 'savings',
              color: 'savings',
              combined: false,
            },
          ],
          colors: ['revenues', 'savings'],
          combinedKeys: [],
          title: 'widgets.savingsStackBar.title',
          devID: 'nocturnal-espresso',
          devPath: 'site-economics->default->savingsStackBar',
        },
      ],
    },
  },
  {
    name: 'site-energy',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'EntitiesResolver',
        'SiteOverviewResolver',
        'EnergyKpiSiteResolver',
        'AncillaryKpiSiteResolver',
        'EnergyCustomKpiSiteResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-5_5',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'site-energy',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'cannibal-shoe',
          devPath: 'site-energy->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 grid-md-6 grid-lg-3',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'selfSufficiencyCard',
          id: 'selfSufficiencyCard',
          totalValue: 'self_sufficiency_rate',
          value: 'self_consumption',
          icon: 'self_sufficiency',
          descriptionType: 'label+value+unit',
          description: 'widgets.selfSufficiencyCard.description.prosumer',
          devID: 'happy-marshmallow',
          devPath: 'site-energy->default->selfSufficiencyCard',
        },
        {
          order: 2,
          className: 'grid-xs-12 grid-md-6 grid-lg-3',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'sharedEnergyCard',
          id: 'sharedEnergyCard',
          totalValue: 'total_shared',
          icon: 'shared_energy',
          descriptionType: 'web:label+value|label+value',
          description: [
            {
              key: 'widgets.sharedEnergyCard.description.prosumer.key_1',
              value: 'from_shared',
            },
            {
              key: 'widgets.sharedEnergyCard.description.prosumer.key_2',
              value: 'to_shared',
            },
          ],
          devID: 'bizarre-cabbage',
          devPath: 'site-energy->default->sharedEnergyCard',
        },
        {
          order: 3,
          className: 'grid-xs-12 grid-md-6 grid-lg-3',
          env: 'web',
          type: 'card',
          gradientBorder: false,

          kpiContext: 'ancillary',
          subtype: 'pollutionCard',
          id: 'pollutionCard',
          totalValue: 'co2_offset_kgs',
          trees: 'co2_offset_trees',
          icon: 'pollution',
          descriptionValue: 'co2_offset_trees',
          descriptionType: '{{trees}}',
          description: {
            line_1: 'widgets.pollutionCard.description.prosumer.line_1',
            line_2: 'widgets.pollutionCard.description.prosumer.line_2',
          },
          devID: 'rampaging-saxophone',
          devPath: 'site-energy->default->pollutionCard',
        },
        {
          order: 4,
          className: 'grid-xs-12 grid-md-6 grid-lg-3',
          env: 'web',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          context: 'site-energy',
          devID: 'angry-marshmallow',
          devPath: 'site-energy->default->map',
        },
        {
          order: 5,
          className: 'grid-xs-12 grid-lg-6',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'consumptionStackBar',
          id: 'consumptionStackBar',
          totalValue: 'consumption',
          graphKeys: [
            {
              key: 'self_consumption_direct',
              color: 'self_consumption',
              combined: false,
            },
            {
              key: 'self_consumption_battery',
              color: 'self_consumption_battery',
              combined: false,
            },
            {
              key: 'from_shared',
              color: 'from_shared',
              combined: false,
              base: false,
            },
            {
              key: 'from_grid',
              color: 'from_grid',
              combined: false,
              base: true,
            },
          ],
          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'self_consumption_battery',
              colorShade: '',
            },
            {
              color: 'from_shared',
              colorShade: '',
            },
            {
              color: 'from_grid',
              colorShade: '60',
            },
          ],
          title: 'widgets.consumptionStackBar.title',
          devID: 'daring-dinosaur',
          devPath: 'site-energy->default->consumptionStackBar',
        },
        {
          order: 6,
          className: 'grid-xs-12 grid-lg-6',
          type: 'graphs',
          gradientBorder: false,
          env: 'web',
          subtype: 'productionStackBar',
          id: 'productionStackBar',
          totalValue: 'production',
          graphKeys: [
            {
              key: 'self_consumption_direct',
              color: 'self_consumption',
              combined: false,
            },
            {
              key: 'production_to_battery',
              color: 'production_to_battery',
              combined: false,
            },
            {
              key: 'to_shared',
              color: 'to_shared',
              combined: true,
              base: false,
            },
            {
              key: 'to_grid',
              color: 'to_grid',
              combined: true,
              base: true,
            },
          ],
          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'production_to_battery',
              colorShade: '',
            },
            {
              color: 'to_shared',
              colorShade: '',
            },
            {
              color: 'to_grid',
              colorShade: '60',
            },
          ],
          title: 'widgets.productionStackBar.title',
          devID: 'zealous-cactus',
          devPath: 'site-energy->default->productionStackBar',
        },
        {
          order: 7,
          className: 'grid-12',
          env: 'web',
          id: 'areaChartSelfConsumptionSite',
          title: 'widgets.areaChartSelfConsumptionCommunity.title',
          type: 'areachart',
          subtype: 'areachart',
          gradientBorder: false,
          colors: ['consumption', 'production', 'self_consumption'],
          graphKeys: ['consumption', 'production', 'self_consumption'],
          devID: 'rambunctious-nacho',
          devPath: 'site-energy->default->areaChartSelfConsumptionSite',
        },
      ],
      administrator: {
        consumer: [
          {
            id: 'selfSufficiencyCard',
            keep: false,
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
          },
          {
            id: 'pollutionCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumptionSite',
            keep: false,
          },

          {
            order: 1,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 pr-lg-0_5 pt-lg-1',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalConsumptionCard',
            id: 'totalConsumptionCard',
            totalValue: 'consumption',
            icon: 'house_import',
            descriptionValue: 'consumption',
            descriptionType: 'label',
            description: 'widgets.totalConsumptionCard.description.consumer',
            devID: 'impish-obelisk',
            devPath:
              'site-energy->administrator->consumer->totalConsumptionCard',
          },
          {
            order: 2,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 px-lg-0_5 pt-lg-1',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'label',
            description: 'widgets.sharedEnergyCard.description.consumer.key_1',
            devID: 'ludicrous-flamingo',
            devPath: 'site-energy->administrator->consumer->sharedEnergyCard',
          },
          {
            order: 3,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 px-lg-0_5 pt-lg-1',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            devID: 'clumsy-xylophone',
            devPath: 'site-energy->administrator->consumer->pollutionCard',
          },
          {
            order: 4,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 pl-lg-0_5 pt-lg-1',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            devID: 'cannibal-enchilada',
            devPath: 'site-energy->administrator->consumer->map',
          },
          {
            order: 5,
            className: 'grid-12 p-1 pt-xs-0_5',
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'rowdy-hedgehog',
            devPath:
              'site-energy->administrator->consumer->consumptionStackBar',
          },
        ],
        producer: [
          {
            id: 'selfSufficiencyCard',
            keep: false,
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
          },
          {
            id: 'pollutionCard',
            keep: false,
          },
          {
            id: 'consumptionStackBar',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumptionSite',
            keep: false,
          },

          {
            order: 1,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalProductionCard',
            id: 'totalProductionCard',
            totalValue: 'production',
            icon: 'house_export',
            descriptionValue: 'production',
            descriptionType: 'label',
            description: 'widgets.totalProductionCard.description.producer',
            devID: 'kooky-rhinoceros',
            devPath:
              'site-energy->administrator->producer->totalProductionCard',
          },
          {
            order: 2,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'keyValue',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.producer.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.producer.key_2',
                value: 'to_shared',
              },
            ],
            devID: 'kooky-xylophone',
            devPath: 'site-energy->administrator->producer->sharedEnergyCard',
          },
          {
            order: 3,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'zippy-lemonade',
            devPath: 'site-energy->administrator->producer->pollutionCard',
          },
          {
            order: 4,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 pl-lg-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            devID: 'ferocious-rhinoceros',
            devPath: 'site-energy->administrator->producer->map',
          },
          {
            order: 5,
            className: 'grid-12 p-1 pt-xs-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: true,
              },
            ],
            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'kooky-iceberg',
            devPath: 'site-energy->administrator->producer->productionStackBar',
          },
        ],
        prosumer: [
          {
            order: 1,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            view: 'site',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'consumption_self_consumption_direct_rate',
                label:
                  'widgets.siteStatsOverviewConsumption.self_consumption_direct',
              },
              {
                key: 'from_grid',
                percentage: 'consumption_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: ['self_consumption', 'from_grid'],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'jubilant-cactus',
            devPath:
              'site-energy->administrator->prosumer->siteStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            view: 'site',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'production_self_consumption_direct_rate',
                label:
                  'widgets.siteStatsOverviewProduction.self_consumption_direct',
              },
              {
                key: 'to_grid',
                percentage: 'production_to_grid_rate',
                label: 'widgets.siteStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: ['self_consumption', 'to_grid'],
            title: 'widgets.siteStatsOverviewProduction.title',
            devID: 'wild-lighthouse',
            devPath:
              'site-energy->administrator->prosumer->siteStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4 pb-xs-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            devID: 'nocturnal-tangerine',
            devPath: 'site-energy->administrator->prosumer->map',
          },
          {
            order: 4,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pb-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'selfSufficiencyCard',
            id: 'selfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            value: 'self_consumption',
            icon: 'self_sufficiency',
            descriptionType: 'label+value+unit',
            description: 'widgets.selfSufficiencyCard.description.prosumer',
            devID: 'playful-hedgehog',
            devPath:
              'site-energy->administrator->prosumer->selfSufficiencyCard',
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pb-xs-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.prosumer.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.prosumer.key_2',
                value: 'to_shared',
              },
            ],
            devID: 'kooky-lollipop',
            devPath: 'site-energy->administrator->prosumer->sharedEnergyCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pb-xs-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.prosumer.line_1',
              line_2: 'widgets.pollutionCard.description.prosumer.line_2',
            },
            devID: 'nutty-ukulele',
            devPath: 'site-energy->administrator->prosumer->pollutionCard',
          },

          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 7,
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'clumsy-saxophone',
            devPath:
              'site-energy->administrator->prosumer->consumptionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'clumsy-obelisk',
            devPath: 'site-energy->administrator->prosumer->productionStackBar',
          },
          {
            order: 10,
            className: 'grid-12 p-1 py-xs-0_5',
            env: 'web',
            id: 'areaChartSelfConsumptionSite',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areachart',
            subtype: 'areachart',
            gradientBorder: false,
            colors: ['consumption', 'production', 'self_consumption'],
            graphKeys: ['consumption', 'production', 'self_consumption'],
            devID: 'spritely-avocado',
            devPath:
              'site-energy->administrator->prosumer->areaChartSelfConsumptionSite',
          },
        ],
        prosumage: [
          {
            order: 1,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            view: 'site',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'consumption_self_consumption_direct_rate',
                label:
                  'widgets.siteStatsOverviewConsumption.self_consumption_direct',
              },
              {
                key: 'self_consumption_battery',
                percentage: 'consumption_self_consumption_battery_rate',
                label:
                  'widgets.siteStatsOverviewConsumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                percentage: 'consumption_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'self_consumption_battery',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'zippy-yogurt',
            devPath:
              'site-energy->administrator->prosumage->siteStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            view: 'site',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'production_self_consumption_direct_rate',
                label:
                  'widgets.siteStatsOverviewProduction.self_consumption_direct',
              },
              {
                key: 'production_to_battery',
                percentage: 'production_to_battery_rate',
                label:
                  'widgets.siteStatsOverviewProduction.production_to_battery',
              },
              {
                key: 'to_grid',
                percentage: 'production_to_grid_rate',
                label: 'widgets.siteStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'production_to_battery',
              'to_grid',
            ],
            title: 'widgets.siteStatsOverviewProduction.title',
            devID: 'playful-flamingo',
            devPath:
              'site-energy->administrator->prosumage->siteStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4 pb-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            devID: 'quirksome-iceberg',
            devPath: 'site-energy->administrator->prosumage->map',
          },
          {
            order: 4,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'selfSufficiencyCard',
            id: 'selfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            value: 'self_consumption',
            icon: 'self_sufficiency',
            descriptionType: 'label+value+unit',
            description: 'widgets.selfSufficiencyCard.description.prosumage',
            devID: 'ludicrous-cabbage',
            devPath:
              'site-energy->administrator->prosumage->selfSufficiencyCard',
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.prosumage.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.prosumage.key_2',
                value: 'to_shared',
              },
            ],
            devID: 'bizarre-buffet',
            devPath: 'site-energy->administrator->prosumage->sharedEnergyCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.prosumage.line_1',
              line_2: 'widgets.pollutionCard.description.prosumage.line_2',
            },
            devID: 'bizarre-saxophone',
            devPath: 'site-energy->administrator->prosumage->pollutionCard',
          },

          {
            order: 7,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'cannibal-tangerine',
            devPath:
              'site-energy->administrator->prosumage->consumptionStackBar',
          },
          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'glowing-jigsaw',
            devPath:
              'site-energy->administrator->prosumage->productionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            id: 'batteryChart',
            title: 'widgets.batteryChart.title',
            type: 'batteryChart',
            gradientBorder: false,
            context: 'site',
            buttons: [
              'widgets.batteryChart.self_consumption',
              'widgets.batteryChart.soc',
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'soc_battery',
                colorShade: '',
              },
            ],
            db_fields: ['battery_net_flow', 'soc_battery'],
            devID: 'angry-waffle',
            devPath: 'site-energy->administrator->prosumage->batteryChart',
          },
          {
            order: 10,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            id: 'areaChartSelfConsumptionSite',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'site',
            graphKeys: ['consumption', 'production', 'self_consumption'],
            colors: ['consumption', 'production', 'self_consumption'],
            devID: 'angry-saxophone',
            devPath:
              'site-energy->administrator->prosumage->areaChartSelfConsumptionSite',
          },
        ],
      },
    },
  },
  {
    name: 'community-economics',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'EntitiesResolver',
        'EconomicsKpiCommunityResolver',
        'CommunityResolver',
        'EconomicsCommunityRankingResolver',
        'EconomicsCustomKpiCommunityResolver',
      ],
    },
    widgets: {
      default: [
        {
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-6_5',
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'community-economics',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'eccentric-gumball',
          devPath: 'community-economics->administrator->default->headerWeb',
        },
        {
          className: 'grid-12 p-1 pb-xs-0_5 pt-xs-0',
          order: 1,
          env: 'web',
          type: 'card',
          gradientBorder: false,
          subtype: 'communityBenefitsCard',
          id: 'communityBenefitsCard',
          totalValue: 'total_benefits',
          icon: 'savings',
          descriptionType: 'dynamic-label',
          additionalFields: [
            {
              field: 'revenues',
              label: 'widgets.communityBenefitsCard.revenues',
            },
            {
              field: 'savings',
              label: 'widgets.communityBenefitsCard.savings',
            },
          ],
          description: 'widgets.communityBenefitsCard.description.default',
          descriptionCallback: 'communityTotalEstimatedBenefits',
          devID: 'wondrous-giraffe',
          devPath:
            'community-economics->administrator->default->communityBenefitsCard',
          drawerConfig: {
            titleKey: 'drawers.communityTotalEstimatedBenefits.title',
            descriptionKey: 'drawers.communityTotalEstimatedBenefits.description',
            listTitleKey: 'drawers.communityTotalEstimatedBenefits.list_title',
            listTitleSavingsKey: 'drawers.communityTotalEstimatedBenefits.list_title_savings'
          },
        },
        {
          className: 'grid-12 p-1 py-xs-0_5',
          order: 2,
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'savingsStackBar',
          id: 'savingsStackBar',
          totalValue: 'total_benefits',
          graphKeys: [
            {
              key: 'revenues',
              color: 'revenues',
              combined: false,
            },
            {
              key: 'savings',
              color: 'savings',
              combined: false,
            },
          ],
          colors: ['revenues', 'savings'],
          title: 'widgets.savingsStackBar.title',
          devID: 'angry-giraffe',
          devPath:
            'community-economics->administrator->default->savingsStackBar',
        },
        {
          className: 'grid-12 p-1 py-xs-0_5',
          order: 3,
          type: 'horizontalChart',
          gradientBorder: false,
          subtype: 'horizontalChart',
          id: 'horizontalChartEconomics',
          entity: 'community',
          context: 'economics',
          rankingKpi: 'total_benefits',
          rankingKpiName: 'widgets.horizontalChart.economics.benefits',
          graphKeys: ['revenues', 'savings'],
          combinedKeys: [],
          buttons: [
            'widgets.horizontalChart.economics.revenues',
            'widgets.horizontalChart.economics.savings',
          ],
          colors: [
            {
              color: 'revenues',
              colorShade: '',
            },
            {
              color: 'savings',
              colorShade: '',
            },
          ],
          title: 'widgets.horizontalChart.economics.title',
          devID: 'ferocious-banana',
          devPath:
            'community-economics->administrator->default->horizontalChart',
        },
      ],
    },
  },
  {
    name: 'community-energy',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'EntitiesResolver',
        'CommunityResolver',
        'EnergyCommunityRankingResolver',
        'EnergyKpiCommunityResolver',
        'AncillaryKpiCommunityResolver',
        'EnergyCustomKpiCommunityResolver',
      ],
    },
    widgets: {
      default: [
        {
          className: 'grid-12 mb-13 mb-sm-12 mb-lg-5_5',
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'community-energy',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'mirthful-nacho',
          devPath: 'community-energy->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'communityStatsOverviewConsumption',
          totalValue: 'consumption',
          color: 'consumption',
          view: 'community',
          graphDataKeys: [
            {
              key: 'self_consumption_direct',
              percentage: 'consumption_self_consumption_direct_rate',
              label:
                'widgets.communityStatsOverviewConsumption.self_consumption_direct',
            },
            {
              key: 'from_grid',
              percentage: 'consumption_from_grid_rate',
              label: 'widgets.communityStatsOverviewConsumption.from_grid',
            },
          ],
          graphColors: ['self_consumption', 'from_grid'],
          title: 'widgets.communityStatsOverviewConsumption.title',
          devID: 'boisterous-yogurt',
          devPath:
            'community-energy->default->communityStatsOverviewConsumption',
        },
        {
          className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
          order: 2,
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'communityStatsOverviewProduction',
          totalValue: 'production',
          color: 'production',
          view: 'community',
          graphDataKeys: [
            {
              key: 'self_consumption_direct',
              percentage: 'production_self_consumption_direct_rate',
              label:
                'widgets.communityStatsOverviewProduction.self_consumption_direct',
            },
            {
              key: 'to_grid',
              percentage: 'production_to_grid_rate',
              label: 'widgets.communityStatsOverviewProduction.to_grid',
            },
          ],
          graphColors: ['self_consumption', 'to_grid'],
          title: 'widgets.communityStatsOverviewProduction.title',
          devID: 'rowdy-shoe',
          devPath:
            'community-energy->default->communityStatsOverviewProduction',
        },
        {
          order: 4,
          className: 'grid-xs-12 grid-lg-4 pb-xs-0_5 pt-xs-0',
          env: 'web',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          devID: 'unruly-waffle',
          devPath: 'community-energy->default->map',
        },
        {
          className: 'grid-xs-12 grid-md-6 grid-lg-3',
          order: 5,
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,
          subtype: 'totalSitesCard',
          id: 'totalSitesCard',
          totalValue: 'sites_count',
          icon: 'sites',
          descriptionType: 'totalSitesCard',
          description: [
            {
              key: 'widgets.totalSitesCard.description.default.consumer',
              value: 'consumer',
            },
            {
              key: 'widgets.totalSitesCard.description.default.producer',
              value: 'producer',
            },
            {
              key: 'widgets.totalSitesCard.description.default.prosumage',
              value: 'prosumage',
            },
            {
              key: 'widgets.totalSitesCard.description.default.prosumer',
              value: 'prosumer',
            },
          ],
          devID: 'ludicrous-jigsaw',
          devPath: 'community-energy->default->totalSitesCard',
        },
        {
          className: 'grid-xs-12 grid-md-6 grid-lg-3',
          order: 7,
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,
          subtype: 'communitySelfSufficiencyCard',
          id: 'communitySelfSufficiencyCard',
          totalValue: 'self_sufficiency_rate',
          value: 'self_consumption',
          icon: 'self_sufficiency',
          descriptionType: 'label+value+unit',
          description:
            'widgets.communitySelfSufficiencyCard.description.default',
          devID: 'waggish-juice',
          devPath: 'community-energy->default->communitySelfSufficiencyCard',
        },
        {
          className: 'grid-xs-12 grid-md-6 grid-lg-3',
          order: 6,
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,
          subtype: 'communitySharedEnergyCard',
          id: 'communitySharedEnergyCard',
          totalValue: 'total_shared',
          icon: 'shared_energy',
          descriptionType: 'label',
          description: 'widgets.communitySharedEnergyCard.description.default',
          devID: 'jubilant-pajamas',
          devPath: 'community-energy->default->communitySharedEnergyCard',
        },
        {
          className: 'grid-xs-12 grid-md-6 grid-lg-3',
          order: 8,
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,
          subtype: 'communityPollutionCard',
          id: 'communityPollutionCard',
          totalValue: 'co2_offset_kgs',
          trees: 'co2_offset_trees',
          icon: 'pollution',
          descriptionValue: 'co2_offset_trees',
          descriptionType: '{{trees}}',
          description: {
            line_1: 'widgets.pollutionCard.description.prosumer.line_1',
            line_2: 'widgets.pollutionCard.description.prosumer.line_2',
          },
          devID: 'zealous-yogurt',
          devPath: 'community-energy->default->communityPollutionCard',
        },
        {
          order: 9,
          className: 'grid-xs-12 grid-lg-6',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'consumptionStackBar',
          id: 'consumptionStackBar',
          totalValue: 'consumption',
          graphKeys: [
            {
              key: 'self_consumption_direct',
              color: 'self_consumption',
              combined: false,
            },
            {
              key: 'self_consumption_battery',
              color: 'self_consumption_battery',
              combined: false,
            },
            {
              key: 'total_shared',
              color: 'from_shared',
              combined: false,
              base: false,
            },
            {
              key: 'from_grid',
              color: 'from_grid',
              combined: false,
              base: true,
            },
          ],

          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'self_consumption_battery',
              colorShade: '',
            },
            {
              color: 'from_shared',
              colorShade: '',
            },
            {
              color: 'from_grid',
              colorShade: '60',
            },
          ],
          title: 'widgets.consumptionStackBar.title',
          devID: 'mystical-marshmallow',
          devPath: 'community-energy->default->consumptionStackBar',
        },
        {
          className: 'grid-xs-12 grid-lg-6',
          order: 10,
          type: 'graphs',
          gradientBorder: false,
          env: 'web',
          subtype: 'productionStackBar',
          id: 'productionStackBar',
          totalValue: 'production',
          graphKeys: [
            {
              key: 'self_consumption_direct',
              color: 'self_consumption',
              combined: false,
            },
            {
              key: 'production_to_battery',
              color: 'production_to_battery',
              combined: false,
            },
            {
              key: 'total_shared',
              color: 'to_shared',
              combined: true,
              base: false,
            },
            {
              key: 'to_grid',
              color: 'to_grid',
              combined: true,
              base: true,
            },
          ],

          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'production_to_battery',
              colorShade: '',
            },
            {
              color: 'to_shared',
              colorShade: '',
            },
            {
              color: 'to_grid',
              colorShade: '',
            },
          ],
          title: 'widgets.productionStackBar.title',
          devID: 'nocturnal-flamingo',
          devPath: 'community-energy->default->productionStackBar',
        },
        {
          className: 'grid-xs-12 grid-lg-6',
          order: 11,
          id: 'batteryChart',
          title: 'widgets.batteryChart.title',
          type: 'batteryChart',
          gradientBorder: false,
          context: 'community',
          buttons: ['widgets.batteryChart.self_consumption'],
          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
          ],
          db_fields: ['battery_net_flow'],
          devID: 'mirthful-quokka',
          devPath: 'community-energy->default->batteryChart',
        },
        {
          className: 'grid-xs-12 grid-lg-6',
          order: 12,
          env: 'web',
          id: 'areaChartSelfConsumption',
          title: 'widgets.areaChart.title',
          type: 'areaChart',
          subtype: 'areaChart',
          gradientBorder: false,
          view: 'community',
          graphKeys: ['consumption', 'production', 'total_shared'],
          colors: ['consumption', 'production', 'total_shared'],
          devID: 'mystical-hamburger',
          devPath: 'community-energy->default->areaChartSelfConsumption',
        },
        {
          className: 'grid-12 px-1 py-0_5',
          order: 13,
          type: 'horizontalChartDouble',
          gradientBorder: false,
          subtype: 'horizontalChartDouble',
          id: 'horizontalChartDouble',
          context: 'energy',
          rankingKpi: 'consumption',
          kpiNameLabels: ['consumption', 'production'],
          rankingKpiName: [
            'widgets.horizontalChart.energy.consumption',
            'widgets.horizontalChart.energy.production',
          ],
          graphKeys: [
            [
              'self_consumption_direct',
              'self_consumption_battery',
              'from_shared',
              'from_grid',
            ],
            [
              'self_consumption_direct',
              'production_to_battery',
              'to_shared',
              'to_grid',
            ],
          ],
          combinedKeys: [
            ['from_shared', 'from_grid'],
            ['to_shared', 'to_grid'],
          ],
          buttons: [
            'widgets.horizontalChart.energy.self_consumption_direct',
            'widgets.horizontalChart.energy.self_consumption_battery',
            'widgets.horizontalChart.energy.from_shared',
            'widgets.horizontalChart.energy.from_grid',
          ],
          tooltipColors: [
            [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_battery',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '60',
              },
            ],
            [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_battery',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '60',
              },
            ],
          ],
          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'total_battery',
              colorShade: '',
            },
            {
              color: 'total_shared',
              colorShade: '',
            },
            {
              color: 'total_grid',
              colorShade: '60',
            },
          ],
          title: 'widgets.horizontalChart.energy.title',
          devID: 'turbulent-lollipop',
          devPath: 'community-energy->default->horizontalChartDouble',
        },
      ],
      administrator: {
        consumer: [
          {
            id: 'communityStatsOverviewConsumption',
            keep: false,
          },
          {
            id: 'communityStatsOverviewProduction',
            keep: false,
          },
          {
            id: 'totalSitesCard',
            keep: false,
          },
          {
            id: 'communitySelfSufficiencyCard',
            keep: false,
          },
          {
            id: 'communitySharedEnergyCard',
            keep: false,
          },
          {
            id: 'communityPollutionCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumption',
            keep: false,
          },
          {
            id: 'horizontalChartDouble',
            keep: false,
          },

          {
            order: 1,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalConsumptionCard',
            id: 'totalConsumptionCard',
            totalValue: 'consumption',
            icon: 'house_import',
            descriptionValue: 'consumption',
            descriptionType: 'label',
            description: 'widgets.totalConsumptionCard.description.consumer',
            devID: 'luminous-dragon',
            devPath:
              'community-energy->administrator->consumer->totalConsumptionCard',
          },
          {
            order: 2,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'label',
            description: 'widgets.sharedEnergyCard.description.consumer.key_1',
            devID: 'kooky-hamburger',
            devPath:
              'community-energy->administrator->consumer->sharedEnergyCard',
          },
          {
            order: 3,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            devID: 'rampaging-vortex',
            devPath: 'community-energy->administrator->consumer->pollutionCard',
          },
          {
            order: 4,
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'community-energy',
            devID: 'giddy-waffle',
            devPath: 'community-energy->administrator->consumer->map',
          },
          {
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'total_shared',
                color: 'total_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'kooky-avocado',
            devPath:
              'community-energy->administrator->consumer->consumptionStackBar',
          },
          {
            order: 5,
            type: 'horizontalChart',
            gradientBorder: false,
            subtype: 'horizontalChart',
            id: 'horizontalChart',
            context: 'energy',
            rankingKpi: 'consumption',
            rankingKpiName: 'widgets.horizontalChart.energy.consumption',
            graphKeys: ['from_shared', 'from_grid'],
            combinedKeys: ['from_shared', 'from_grid'],
            buttons: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'rambunctious-waffle',
            devPath:
              'community-energy->administrator->consumer->horizontalChart',
          },
        ],
        producer: [
          {
            id: 'communityStatsOverviewConsumption',
            keep: false,
          },
          {
            id: 'communityStatsOverviewProduction',
            keep: false,
          },
          {
            id: 'totalSitesCard',
            keep: false,
          },
          {
            id: 'communitySelfSufficiencyCard',
            keep: false,
          },
          {
            id: 'communitySharedEnergyCard',
            keep: false,
          },
          {
            id: 'communityPollutionCard',
            keep: false,
          },
          {
            id: 'consumptionStackBar',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumption',
            keep: false,
          },
          {
            id: 'horizontalChartDouble',
            keep: false,
          },

          {
            order: 1,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalProductionCard',
            id: 'totalProductionCard',
            totalValue: 'production',
            icon: 'house_export',
            descriptionValue: 'production',
            descriptionType: 'label',
            description: 'widgets.totalProductionCard.description.producer',
            devID: 'quirksome-vortex',
            devPath:
              'community-energy->administrator->producer->totalProductionCard',
          },
          {
            order: 2,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'keyValue',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.producer.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.producer.key_2',
                value: 'to_shared',
              },
            ],
            devID: 'waggish-glove',
            devPath:
              'community-energy->administrator->producer->sharedEnergyCard',
          },
          {
            order: 3,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'hysterical-glove',
            devPath: 'community-energy->administrator->producer->pollutionCard',
          },
          {
            order: 4,
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'community-energy',
            devID: 'nutty-giraffe',
            devPath: 'community-energy->administrator->producer->map',
          },
          {
            order: 5,
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'total_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: true,
              },
            ],

            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'waggish-cabbage',
            devPath:
              'community-energy->administrator->producer->productionStackBar',
          },
          {
            order: 6,
            type: 'horizontalChart',
            gradientBorder: false,
            subtype: 'horizontalChart',
            id: 'horizontalChart',
            context: 'energy',
            rankingKpi: 'production',
            rankingKpiName: 'widgets.horizontalChart.energy.production',
            graphKeys: ['production_to_battery', 'to_shared', 'to_grid'],
            combinedKeys: ['to_shared', 'to_grid'],
            buttons: [
              'widgets.horizontalChart.energy.to_shared',
              'widgets.horizontalChart.energy.to_grid',
            ],
            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'frisky-pencil',
            devPath:
              'community-energy->administrator->producer->horizontalChart',
          },
        ],
        consumer_producer: [
          {
            id: 'communitySharedEnergyCard',
            keep: false,
          },
          {
            id: 'totalSitesCard',
            keep: false,
          },
          {
            id: 'communityPollutionCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },

          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4 pb-xs-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'community-energy',
            devID: 'luminous-zeppelin',
            devPath: 'community-energy->administrator->consumer_producer->map',
          },
          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 p-lg-0_5',
            order: 5,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'communitySelfSufficiencyCard',
            id: 'communitySelfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            value: 'self_consumption',
            icon: 'self_sufficiency',
            descriptionType: 'label+value+unit',
            description:
              'widgets.communitySelfSufficiencyCard.description.default',
            devID: 'waggish-lemonade',
            devPath: 'community-energy->default->communitySelfSufficiencyCard',
          },

          {
            order: 4,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'label',
            description:
              'widgets.communitySharedEnergyCard.description.default',
            devID: 'zealous-igloo',
            devPath:
              'community-energy->administrator->consumer_producer->sharedEnergyCard',
          },

          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pl-lg-0_5',
            order: 6,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'unruly-ukulele',
            devPath:
              'community-energy->administrator->consumer_producer->pollutionCard',
          },

          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 7,
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'total_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'eccentric-cactus',
            devPath:
              'community-energy->administrator->consumer_producer->consumptionStackBar',
          },
          {
            className: 'grid-xs-12 grid-lg-6  p-1 py-xs-0_5 pl-lg-0_5',
            order: 8,
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'total_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'bizarre-panchin',
            devPath:
              'community-energy->administrator->consumer_producer->productionStackBar',
          },
          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 11,
            id: 'areaChartSelfConsumption',
          },
          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 12,
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            context: 'energy',
            rankingKpi: 'consumption',

            kpiNameLabels: ['consumption', 'production'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.consumption',
              'widgets.horizontalChart.energy.production',
            ],
            graphKeys: [
              ['self_consumption_direct', 'from_shared', 'from_grid'],
              ['self_consumption_direct', 'to_shared', 'to_grid'],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.self_consumption_direct',
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'frisky-meatball',
            devPath:
              'community-energy->administrator->consumer_producer->horizontalChartDouble',
          },
        ],
        prosumer: [
          {
            id: 'communitySharedEnergyCard',
            keep: false,
          },
          {
            id: 'totalSitesCard',
            keep: false,
          },
          {
            id: 'communityPollutionCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },

          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4 py-0_5 pt-lg-0',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'community-energy',
            devID: 'luminous-zeppelin',
            devPath: 'community-energy->administrator->consumer_producer->map',
          },
          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 p-lg-0_5',
            order: 5,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'communitySelfSufficiencyCard',
            id: 'communitySelfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            value: 'self_consumption',
            icon: 'self_sufficiency',
            descriptionType: 'label+value+unit',
            description:
              'widgets.communitySelfSufficiencyCard.description.default',
            devID: 'waggish-bandana',
            devPath: 'community-energy->default->communitySelfSufficiencyCard',
          },

          {
            order: 4,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'label',
            description:
              'widgets.communitySharedEnergyCard.description.default',
            devID: 'zealous-igloo',
            devPath:
              'community-energy->administrator->consumer_producer->sharedEnergyCard',
          },

          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pl-lg-0_5',
            order: 6,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'unruly-ukulele',
            devPath:
              'community-energy->administrator->consumer_producer->pollutionCard',
          },

          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 7,
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'total_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'eccentric-banana',
            devPath:
              'community-energy->administrator->consumer_producer->consumptionStackBar',
          },
          {
            className: 'grid-xs-12 grid-lg-6  p-1 py-xs-0_5 pl-lg-0_5',
            order: 8,
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'total_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'bizarre-kangaroo',
            devPath:
              'community-energy->administrator->consumer_producer->productionStackBar',
          },

          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 11,
            id: 'areaChartSelfConsumption',
          },
          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 12,
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            context: 'energy',
            rankingKpi: 'consumption',

            kpiNameLabels: ['consumption', 'production'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.consumption',
              'widgets.horizontalChart.energy.production',
            ],
            graphKeys: [
              ['self_consumption_direct', 'from_shared', 'from_grid'],
              ['self_consumption_direct', 'to_shared', 'to_grid'],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.self_consumption_direct',
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '',
                },
              ],
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '',
                },
              ],
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'frisky-vortex',
            devPath:
              'community-energy->administrator->consumer_producer->horizontalChartDouble',
          },
        ],
        prosumage: [
          {
            id: 'totalSitesCard',
            keep: false,
          },

          {
            order: 1,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'communityStatsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            view: 'community',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'consumption_self_consumption_direct_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_direct',
              },
              {
                key: 'self_consumption_battery',
                percentage: 'consumption_self_consumption_battery_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                percentage: 'consumption_from_grid_rate',
                label: 'widgets.memberStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'self_consumption_battery',
              'from_grid',
            ],
            title: 'widgets.communityStatsOverviewConsumption.title',
            values: [
              {
                label:
                  'widgets.communityStatsOverviewConsumption.self_consumption_direct',
                totalPercentage: 'self_consumption_direct',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'self_consumption_direct',
                    color: 'self_consumption',
                  },
                ],
              },
              {
                label:
                  'widgets.communityStatsOverviewConsumption.self_consumption_battery',
                totalPercentage: 'self_consumption_battery',
                id: 'self_consumption_battery',
                progress: [
                  {
                    value: 'self_consumption_direct',
                    color: 'self_consumption',
                  },
                  {
                    value: 'self_consumption_battery',
                    color: 'self_consumption_battery',
                  },
                ],
              },
              {
                label: 'widgets.memberStatsOverviewConsumption.from_grid',
                totalPercentage: 'from_grid',
                id: 'from_grid',
                progress: [
                  {
                    value: 'self_consumption_direct',
                    color: 'self_consumption',
                  },
                  {
                    value: 'self_consumption_battery',
                    color: 'self_consumption_battery',
                  },
                  {
                    value: 'from_grid',
                    color: 'from_grid',
                  },
                ],
              },
            ],
            devID: 'eccentric-shoe',
            devPath:
              'community-energy->administrator->prosumage->communityStatsOverviewConsumption',
          },
          {
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            order: 2,
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'communityStatsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            view: 'community',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'production_self_consumption_direct_rate',
                label:
                  'widgets.memberStatsOverviewProduction.self_consumption_direct',
              },
              {
                key: 'production_to_battery',
                percentage: 'production_to_battery_rate',
                label:
                  'widgets.memberStatsOverviewProduction.production_to_battery',
              },
              {
                key: 'to_grid',
                percentage: 'production_to_grid_rate',
                label: 'widgets.memberStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'production_to_battery',
              'to_grid',
            ],
            title: 'widgets.communityStatsOverviewProduction.title',
            devID: 'whacky-buffet',
            devPath:
              'community-energy->administrator->prosumage->communityStatsOverviewProduction',
          },
          {
            className: 'grid-xs-12 grid-lg-4 py-0_5 pt-lg-0',
            order: 3,
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            devID: 'nutty-cat',
            devPath: 'community-energy->administrator->prosumage->map',
          },
          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 px-lg-0_5',
            order: 5,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'communitySelfSufficiencyCard',
            id: 'communitySelfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            value: 'self_consumption',
            icon: 'self_sufficiency',
            descriptionType: 'label+value+unit',
            description:
              'widgets.communitySelfSufficiencyCard.description.default',
            devID: 'mirthful-pencil',
            devPath:
              'community-energy->administrator->prosumage->communitySelfSufficiencyCard',
          },
          {
            order: 4,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'communitySharedEnergyCard',
            id: 'communitySharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'label',
            description: 'widgets.communitySharedEnergyCard.description.default',
            devID: 'hysterical-pajamas',
            devPath:
              'community-energy->administrator->prosumage->communitySharedEnergyCard',
          },
          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 px-lg-0_5',
            order: 6,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'communityPollutionCard',
            id: 'communityPollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',

            kpiContext: 'ancillary',
            description: {
              line_1: 'widgets.memberPollutionCard.description.prosumer.line_1',
              line_2: 'widgets.memberPollutionCard.description.prosumer.line_2',
            },
            devID: 'bizarre-avocado',
            devPath:
              'community-energy->administrator->prosumage->communityPollutionCard',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 7,
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'total_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'peculiar-vortex',
            devPath:
              'community-energy->administrator->prosumage->consumptionStackBar',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            order: 8,
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'total_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'ludicrous-buffet',
            devPath:
              'community-energy->administrator->prosumage->productionStackBar',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 9,
            id: 'batteryChart',
            title: 'widgets.batteryChart.title',
            type: 'batteryChart',
            gradientBorder: false,
            context: 'community',
            buttons: ['widgets.batteryChart.self_consumption'],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
            ],
            db_fields: ['battery_net_flow'],
            devID: 'boisterous-lollipop',
            devPath: 'community-energy->administrator->prosumage->batteryChart',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            order: 10,
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChart.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'community',
            graphKeys: ['consumption', 'production', 'total_shared'],
            colors: ['consumption', 'production', 'total_shared'],
            devID: 'masculine-lighthouse',
            devPath:
              'community-energy->administrator->prosumage->areaChartSelfConsumption',
          },
          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 11,
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            context: 'energy',
            rankingKpi: 'consumption',
            kpiNameLabels: ['consumption', 'production'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.consumption',
              'widgets.horizontalChart.energy.production',
            ],
            graphKeys: [
              [
                'self_consumption_direct',
                'self_consumption_battery',
                'from_shared',
                'from_grid',
              ],
              [
                'self_consumption_direct',
                'production_to_battery',
                'to_shared',
                'to_grid',
              ],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.self_consumption_direct',
              'widgets.horizontalChart.energy.self_consumption_battery',
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_battery',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'zany-gumball',
            devPath:
              'community-energy->administrator->prosumage->horizontalChartDouble',
          },
        ],
        prosumer_battery: [
          {
            id: 'totalSitesCard',
            keep: false,
          },

          {
            order: 1,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'communityStatsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            view: 'community',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'consumption_self_consumption_direct_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_direct',
              },
              {
                key: 'self_consumption_battery',
                percentage: 'consumption_self_consumption_battery_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                percentage: 'consumption_from_grid_rate',
                label: 'widgets.memberStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'self_consumption_battery',
              'from_grid',
            ],
            title: 'widgets.communityStatsOverviewConsumption.title',
            values: [
              {
                label:
                  'widgets.communityStatsOverviewConsumption.self_consumption_direct',
                totalPercentage: 'self_consumption_direct',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'self_consumption_direct',
                    color: 'self_consumption',
                  },
                ],
              },
              {
                label:
                  'widgets.communityStatsOverviewConsumption.self_consumption_battery',
                totalPercentage: 'self_consumption_battery',
                id: 'self_consumption_battery',
                progress: [
                  {
                    value: 'self_consumption_direct',
                    color: 'self_consumption',
                  },
                  {
                    value: 'self_consumption_battery',
                    color: 'self_consumption_battery',
                  },
                ],
              },
              {
                label: 'widgets.memberStatsOverviewConsumption.from_grid',
                totalPercentage: 'from_grid',
                id: 'from_grid',
                progress: [
                  {
                    value: 'self_consumption_direct',
                    color: 'self_consumption',
                  },
                  {
                    value: 'self_consumption_battery',
                    color: 'self_consumption_battery',
                  },
                  {
                    value: 'from_grid',
                    color: 'from_grid',
                  },
                ],
              },
            ],
            devID: 'eccentric-shoe',
            devPath:
              'community-energy->administrator->prosumage->communityStatsOverviewConsumption',
          },
          {
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            order: 2,
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'communityStatsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            view: 'community',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                percentage: 'production_self_consumption_direct_rate',
                label:
                  'widgets.memberStatsOverviewProduction.self_consumption_direct',
              },
              {
                key: 'production_to_battery',
                percentage: 'production_to_battery_rate',
                label:
                  'widgets.memberStatsOverviewProduction.production_to_battery',
              },
              {
                key: 'to_grid',
                percentage: 'production_to_grid_rate',
                label: 'widgets.memberStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: [
              'self_consumption',
              'production_to_battery',
              'to_grid',
            ],
            title: 'widgets.communityStatsOverviewProduction.title',
            devID: 'whacky-buffet',
            devPath:
              'community-energy->administrator->prosumage->communityStatsOverviewProduction',
          },
          {
            className: 'grid-xs-12 grid-lg-4 pb-xs-0_5 pt-xs-0',
            order: 3,
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            devID: 'nutty-cat',
            devPath: 'community-energy->administrator->prosumage->map',
          },
          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 px-lg-0_5',
            order: 5,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'communitySelfSufficiencyCard',
            id: 'communitySelfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            value: 'self_consumption',
            icon: 'self_sufficiency',
            descriptionType: 'label+value+unit',
            description:
              'widgets.communitySelfSufficiencyCard.description.default',
            devID: 'mirthful-pencil',
            devPath:
              'community-energy->administrator->prosumage->communitySelfSufficiencyCard',
          },
          {
            order: 4,
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'communitySharedEnergyCard',
            id: 'communitySharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'label',
            description: 'widgets.communitySharedEnergyCard.description.default',
            devID: 'hysterical-pajamas',
            devPath:
              'community-energy->administrator->prosumage->communitySharedEnergyCard',
          },
          {
            className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pl-lg-0_5',
            order: 6,
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'communityPollutionCard',
            id: 'communityPollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            kpiContext: 'ancillary',
            description: {
              line_1: 'widgets.memberPollutionCard.description.prosumer.line_1',
              line_2: 'widgets.memberPollutionCard.description.prosumer.line_2',
            },
            devID: 'bizarre-avocado',
            devPath:
              'community-energy->administrator->prosumage->communityPollutionCard',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 7,
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'total_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'peculiar-vortex',
            devPath:
              'community-energy->administrator->prosumage->consumptionStackBar',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            order: 8,
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'total_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'ludicrous-buffet',
            devPath:
              'community-energy->administrator->prosumage->productionStackBar',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 9,
            id: 'batteryChart',
            title: 'widgets.batteryChart.title',
            type: 'batteryChart',
            gradientBorder: false,
            context: 'community',
            buttons: ['widgets.batteryChart.self_consumption'],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
            ],
            db_fields: ['battery_net_flow'],
            devID: 'boisterous-lollipop',
            devPath: 'community-energy->administrator->prosumage->batteryChart',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            order: 10,
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChart.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'community',
            graphKeys: ['consumption', 'production', 'total_shared'],
            colors: ['consumption', 'production', 'total_shared'],
            devID: 'zany-lighthouse',
            devPath:
              'community-energy->administrator->prosumage->areaChartSelfConsumption',
          },
          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 11,
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            context: 'energy',
            rankingKpi: 'consumption',
            kpiNameLabels: ['consumption', 'production'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.consumption',
              'widgets.horizontalChart.energy.production',
            ],
            graphKeys: [
              [
                'self_consumption_direct',
                'self_consumption_battery',
                'from_shared',
                'from_grid',
              ],
              [
                'self_consumption_direct',
                'production_to_battery',
                'to_shared',
                'to_grid',
              ],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.self_consumption_direct',
              'widgets.horizontalChart.energy.self_consumption_battery',
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
              [
                {
                  color: 'self_consumption',
                  colorShade: '',
                },
                {
                  color: 'total_battery',
                  colorShade: '',
                },
                {
                  color: 'total_shared',
                  colorShade: '',
                },
                {
                  color: 'total_grid',
                  colorShade: '60',
                },
              ],
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'total_battery',
                colorShade: '',
              },
              {
                color: 'total_shared',
                colorShade: '',
              },
              {
                color: 'total_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'zany-gumball',
            devPath:
              'community-energy->administrator->prosumage->horizontalChartDouble',
          },
        ],
      },
    },
  },
];

const confMap: any = _.keyBy(BASE_MODULES, 'name');

export function arrayReplaceCustomizer(
  objValue: any,
  srcValue: any
): any[] | undefined {
  if (_.isArray(srcValue)) {
    return srcValue;
  }
  return undefined;
}

export function mergeConfigs(additionalModules: any) {
  const resultMap: { [key: string]: any } = { ...confMap };

  const _additionalModules = _.keyBy(additionalModules, 'name');

  Object.keys(_additionalModules).forEach((name) => {
    const overrideObj = _additionalModules[name];
    const baseObj = resultMap[name];

    if (baseObj) {
      resultMap[name] = _.mergeWith(
        {},
        baseObj,
        overrideObj,
        arrayReplaceCustomizer
      );
    } else {
      resultMap[name] = overrideObj;
    }
  });

  const finalMergedConfig = _.values(resultMap);

  finalMergedConfig.forEach((module: any) => {
    if (module.widgets && typeof module.widgets === 'object') {
      const widgets = module.widgets;
      const hasAdmin = Object.prototype.hasOwnProperty.call(widgets, 'administrator')
      const hasSupervisor = Object.prototype.hasOwnProperty.call(widgets, 'supervisor')

      if (hasAdmin && !hasSupervisor) {
        widgets.supervisor = widgets.administrator;
      } else if (hasSupervisor && !hasAdmin) {
        widgets.administrator = widgets.supervisor;
      }
    }
  });

  return _.values(finalMergedConfig);
}
// interface AppModuleConfig {
//   name: string;
//   widgets?: any[]; // Esempio, usa tipi più specifici
//   layouts?: { [key: string]: any[] }; // Esempio
//   [key: string]: any; // Permetti altre proprietà
// }

// const confMap: any = _.keyBy(conf, 'name');
// const PLNmap: any = _.keyBy(PLENITUDE, 'name');

// // 2. Funzione custom per _.mergeWith che sostituisce gli array
// function arrayReplaceCustomizer(objValue: any, srcValue: any): any[] | undefined {
//   if (_.isArray(srcValue)) {
//     // Se il valore sorgente (dall'override) è un array, usalo per sostituire
//     return srcValue;
//   }
//   // Altrimenti, restituisci undefined per lasciare che mergeWith gestisca
//   // ricorsivamente gli oggetti o sovrascriva i valori semplici.
//   return undefined;
// }

// // Crea la mappa risultante, partendo dalla base
// const resultMap: { [key: string]: AppModuleConfig } = { ...confMap };

// // Itera sulla mappa degli override per aggiornare o aggiungere
// Object.keys(PLNmap).forEach((name) => {
//   const overrideObj = PLNmap[name];
//   const baseObj = resultMap[name];

//   if (baseObj) {
//     // Chiave esiste: Unisci l'oggetto base e l'override usando mergeWith
//     // Il '{}' iniziale assicura che non modifichiamo l'oggetto base originale
//     resultMap[name] = _.mergeWith({}, baseObj, overrideObj, arrayReplaceCustomizer);
//   } else {
//     // Chiave nuova: Aggiungila direttamente
//     resultMap[name] = overrideObj;
//   }
// });

// // 4. Ottieni l'array finale dai valori della mappa
// const finalMergedConfig: AppModuleConfig[] =

// console.log('merge', finalMergedConfig )

// export default conf;
